import { ButtonProps } from "../../../models/IButton";
import styles from "./Button.module.scss";

const Button = ({
  large,
  secondary,
  disabled,
  disableSecondary,
  link,
  customClass,
  label,
  handleClick,
  width,
  height,
  tabIndex,
  type,
  id,
}: ButtonProps) => {
  const buttonClassName = `${styles.commonBtn} ${
    large ? styles.largeBtn : ""
  } ${secondary ? styles.secondary : ""} ${disabled ? styles.disabled : ""} ${
    disableSecondary ? styles.disableSecondary : ""
  } ${link ? styles.link : ""}`;

  const isButtonDisabled = disabled || disableSecondary;

  return (
    <button
      style={{ width: width, height: height }}
      onClick={handleClick}
      className={`${buttonClassName} ${customClass} ${
        !link ? styles.tabIndex : null
      }`}
      disabled={isButtonDisabled ? disabled : undefined}
      tabIndex={tabIndex}
      type={type || "submit"}
      id={id}
    >
      {label}
    </button>
  );
};

export default Button;
